export default __webpack_public_path__ + "static/icon-29-4-1568afab6d28dbdd668d075003f5e297.png";